import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {AppRoutingModule} from './app-routing.module';
import {EsriMapViewComponent} from '../components/esri-map-view/esri-map-view.component';
import {BannerComponent} from '../components/banner/banner.component';
import {EsriSceneViewComponent} from '../components/esri-scene-view/esri-scene-view.component';
import {DragZoomComponent} from '../components/drag-zoom/drag-zoom.component';
import {PreviousExtentComponent} from '../components/previous-extent/previous-extent.component';
import {CoordinateComponent} from '../components/coordinate/coordinate.component';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatMenuModule} from '@angular/material/menu';
import {MatFormFieldModule} from '@angular/material/form-field';

@NgModule({
  declarations: [
    EsriMapViewComponent,
    BannerComponent,
    EsriSceneViewComponent,
    DragZoomComponent,
    PreviousExtentComponent,
    CoordinateComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    MatIconModule,
    MatTooltipModule,
    MatMenuModule,
    MatFormFieldModule
  ],
  exports: [
    EsriMapViewComponent,
    BannerComponent,
    EsriSceneViewComponent,
    DragZoomComponent,
    PreviousExtentComponent,
    CoordinateComponent
  ]
})
export class ViewModule { }
